import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize } = redesignTheme;

export type HeaderNavStyleProps = {
  navCollapseAt: number;
};

export const useHeaderNavStyles = makeStyles({
  nav: ({ navCollapseAt }: HeaderNavStyleProps) => ({
    display: 'flex',
    alignItems: 'stretch',
    alignSelf: 'stretch',
    margin: '-12px 0',
    flex: 1,
    justifyContent: 'center',
    minWidth: 0,
    [`@media (max-width: ${navCollapseAt}px)`]: {
      display: 'none',
    },
  }),

  navItem: {
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '0 20px',
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.overlay,
    lineHeight: 1.6,
    whiteSpace: 'nowrap',
    borderBottom: '2px solid transparent',
    transition: 'border-color 0.15s ease',
    '&:hover': {
      color: colors.overlay,
    },
  },

  navItemActive: {
    fontFamily: fonts.opensansBold,
    lineHeight: 1.4,
    borderBottomColor: colors.primaryDark,
  },
});
